// PT progress helpers shared by the client home snapshot and the account menu.

/** The client's active (paid, non-trial) Fitness Trainer package in ongoingRequestArray, if any */
export const activePtPackage = (ongoingRequestArray) =>
    ongoingRequestArray?.find(
        (req) =>
            req.requestType === "Fitness Trainer" &&
            req.spJobEntity?.isTrial === false &&
            req.serviceCosts?.serviceDuration > 0
    )

/** The client's progress page for that package's trainer */
export const progressPath = (trainerId, clientId) =>
    `/home/personal-training/progress/${trainerId || 0}/${clientId}`
